export default {
  createClassType: '新增-类别类型',
  editClassType: '编辑-类别类型',
  viewClassType: '查看-类别类型',
  generalAttributes: '通用属性',
  remark: '备注',
}
